import { render, staticRenderFns } from "./base-info.vue?vue&type=template&id=ac3da8de&scoped=true&"
import script from "./base-info.vue?vue&type=script&lang=ts&"
export * from "./base-info.vue?vue&type=script&lang=ts&"
import style0 from "./base-info.vue?vue&type=style&index=0&id=ac3da8de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3da8de",
  null
  
)

export default component.exports